import {
  type BaseCustomField,
  type CustomFieldListResponse,
  type CustomFieldType,
  CustomFieldTypeName,
} from '@air/api/types';

export const selectableCustomFields = [CustomFieldTypeName.singleSelect, CustomFieldTypeName.multiSelect];

export const getIsFieldTypeSelectable = ({
  fieldTypeId,
  fieldTypes,
}: {
  fieldTypeId: string;
  fieldTypes: CustomFieldType[] | undefined;
}) => {
  if (!fieldTypes) {
    return false;
  }

  return fieldTypes.some((ft) => ft.id === fieldTypeId && selectableCustomFields.includes(ft.title));
};

const searchableCustomFieldTypes = new Set<CustomFieldTypeName>([
  ...selectableCustomFields,
  CustomFieldTypeName.plainText,
  CustomFieldTypeName.date,
]);

export const getSearchableCustomFields = (customFields: BaseCustomField[]) =>
  customFields.filter((customField) => searchableCustomFieldTypes.has(customField.type.title));

export const editCustomFieldsInCache = ({
  existingCustomFields,
  newCustomField,
}: {
  existingCustomFields?: CustomFieldListResponse;
  newCustomField: Pick<BaseCustomField, 'description' | 'id' | 'name'>;
}) => {
  if (!existingCustomFields) {
    return;
  }

  return {
    ...existingCustomFields,
    data: existingCustomFields.data?.map((customField) => {
      if (customField.id === newCustomField.id) {
        return {
          ...customField,
          name: newCustomField.name,
          description: newCustomField.description,
        };
      }

      return customField;
    }),
  };
};
